module.exports = __webpack_public_path__ + "static/media/schade.b8fb6c6c.png";